import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { FadeIn } from 'common/components/core/animations';

class PositionedTooltip extends Component {
    shouldComponentUpdate() {
        return true;
    }
    render() {
        const {
            theme,
            children,
            isHovered,
            tooltip,
            tooltipPosition
        } = this.props;
        const positionClass = `tooltip${
            tooltipPosition.charAt(0).toUpperCase() + tooltipPosition.slice(1)
        }`;
        return isHovered ? (
            <CSSTransitionGroup
                transitionAppear
                transitionAppearTimeout={0}
                transitionName={FadeIn}
                transitionEnterTimeout={400}
                transitionLeaveTimeout={0}
            >
                <div
                    className={classnames(theme.tooltip, {
                        [theme.tooltipActive]: isHovered,
                        [theme[positionClass]]: theme[positionClass]
                    })}
                >
                    <span className={theme.tooltipInner}>{tooltip}</span>
                    {children}
                </div>
            </CSSTransitionGroup>
        ) : null;
    }
}

export default themr('PositionedTooltip')(PositionedTooltip);
